
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $b25b7fcf78727a1b$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"j1ObW\",\"index.416b7601.js\",\"q2hol\",\"logo.f32be289.svg\"]"));

var $a330c79505c930d5$exports = {};
$a330c79505c930d5$exports = new URL("logo.f32be289.svg", import.meta.url).toString();


const $cab2a74c245ce7e2$var$navBarElement = `<div class="nav-bar-wrapper">
        <div class="logo">
            <img src=${(0, (/*@__PURE__*/$parcel$interopDefault($a330c79505c930d5$exports)))} />
            <p class="heading-text">KPHealthCare</p>
        </div>
        <ul class="nav-menu align-to-right">
            <li class=${window.location.pathname === '/index.html' ? 'active' : ''}><a href="index.html">Home</a></li>
            <li class=${window.location.pathname === '/services.html' ? 'active' : ''}><a href="services.html">Our Services</a></li>
            <li class=${window.location.pathname === '/client.html' ? 'active' : ''}><a href="client.html">Our Clients</a></li>
            <li class=${window.location.pathname === '/contact.html' ? 'active' : ''}><a href="contact.html">Contacts</a></li>
        </ul>
        <span class= 'hamburger-menu' style="font-size:30px;cursor:pointer;align-self: center;" onclick="document.getElementById('mySidenav').style.width = '250px';">&#9776;</span>
        <div id="mySidenav" class="sidenav">
  <a href="javascript:void(0)" class="closebtn" onclick=" document.getElementById('mySidenav').style.width = '0';">&times;</a>
  <ul class="drawer-list">
            <li class=${window.location.pathname === '/index.html' || window.location.pathname === '/' ? 'active' : ''}><a href="index.html">Home</a></li>
            <li class=${window.location.pathname === '/services.html' ? 'active' : ''}><a href="services.html">Our Services</a></li>
            <li class=${window.location.pathname === '/client.html' ? 'active' : ''}><a href="client.html">Our Clients</a></li>
            <li class=${window.location.pathname === '/contact.html' ? 'active' : ''}><a href="contact.html">Contacts</a></li>
        </ul>
</div>
    </div>`;
const $cab2a74c245ce7e2$var$footer = `<footer class ='footermain-wrapper'>
        <section class="footer__area-common" >
            <div class="container">
                <div class="row mb-minus-50">
                    <!-- Footer Logo and Social Links -->
                    <div class="col-lg-3 col-6">
                        <div class="footer__widget footer__widget-item-1">
                            <div class="footer__logo mb-30">
                                <a href="index.html">
                                    <img class="img-fluid" src=${(0, (/*@__PURE__*/$parcel$interopDefault($a330c79505c930d5$exports)))}  alt="logo">
                                </a>
                            </div>

                            <div class="footer__content">
                                <p class="mb-0">It is a long established fact that a reader will be distracted</p>
                            </div>

                            <div class="footer__social mt-30">
                                <a href="https://www.instagram.com/"><i class="fa-brands fa-instagram"></i></a>
                                <a href="https://www.facebook.com/"><i class="fab fa-facebook-f"></i></a>
                                <a href="https://twitter.com/"><i class="fa-brands fa-twitter"></i></a>
                                <a href="https://www.linkedin.com/"><i class="fa-brands fa-linkedin-in"></i></a>
                            </div>
                        </div>
                    </div>

                    <!-- Footer Services Links -->
                    <div class="col-lg-2 col-6">
                        <div class="footer__widget footer__widget-item-2">
                            <div class="footer__widget-title">
                                <h4>Services</h4>
                            </div>
                            <div class="footer__link">
                                <ul>
                                    <li><a href="about-us.html">Reliable Rentals</a></li>
                                    <li><a href="about-us.html">Golden Key Properties</a></li>
                                    <li><a href="about-us.html">Swift Home Sales</a></li>
                                    <li><a href="about-us.html">Elite Realty Services</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <!-- Footer Newsletter Subscription -->
                    <div class="col-lg-4 col-6">
                        <div class="footer__widget footer__widget-item-3">
                            <div class="footer__widget-title">
                                <h4>Our newsletter</h4>
                            </div>

                            <div class="footer__subscribe-content">
                                <p class="mb-30">Innovative Medical Equipment Solutions for Your Healthcare Business
Custom Service, Support, and Sales Tailored to Your Needs
                                </p>

                                <!-- <div class="footer__subscribe d-flex mt-30">
                                    <input type="text" placeholder="Enter e-mail">
                                    <button type="submit" class="rr-btn rr-btn__theme">
                                        <span class="btn-wrap">
                                            <span class="text-one"><i class="fa-solid fa-paper-plane"></i></span>
                                            <span class="text-two"><i class="fa-solid fa-paper-plane"></i></span>
                                        </span>
                                    </button>
                                </div> -->
                            </div>
                        </div>
                    </div>

                    <!-- Footer Contact Info -->
                    <div class="col-lg-3 col-6">
                        <div class="footer__widget footer__widget-item-4">
                            <div class="footer__widget-title">
                                <h4>Our Office</h4>
                            </div>

                            <div class="footer__link footer__link-location">
                                <ul>
                                    <li><a href="mailto:debra.holt@example.com"><i class="fa-solid fa-envelope"></i>
                                            kphealthcareltd2020@gmail.com</a></li>
                                    <li><a href="https://maps.app.goo.gl/4XYAPDmpesGnSbsC8"><i
                                                class="fa-solid fa-location-dot"></i> 3891 Ranchview Dr. dev,
                                            cbn 62639</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Footer Bottom Section -->
            <div class="footer__bottom-wrapper">
                <div class="container">
                    <div class="footer__bottom">
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="footer__copyright text-lg-start text-center">
                                    <p class="mb-0">\xa9 <a href="index.html">KpHealthCare</a> 2024 | All Rights Reserved</p>
                                </div>
                            </div>

                            <div class="col-lg-6">
                                <div class="footer__copyright-menu">
                                    <ul>
                                        <li><a href="about-us.html">Trams &amp; Condition</a></li>
                                        <li><a href="about-us.html">Privacy Policy</a></li>
                                        <li><a href="contact.html">Contact Us</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </footer>`;
function $cab2a74c245ce7e2$var$init() {
    document.getElementById('commonNavbar').innerHTML = $cab2a74c245ce7e2$var$navBarElement;
    document.getElementById('commonfooter').innerHTML = $cab2a74c245ce7e2$var$footer;
}
window.addEventListener('scroll', function() {
    var navBarWrapper = document.querySelector('.nav-bar-wrapper');
    if (window.scrollY >= 90) navBarWrapper.classList.add('scroll-Navbar');
    else navBarWrapper.classList.remove('scroll-Navbar');
});
$cab2a74c245ce7e2$var$init();


//# sourceMappingURL=index.416b7601.js.map
